// removed by extract-text-webpack-plugin
module.exports = {"Input":"Input__Input__s67N0","Label":"Input__Label___n-1m","InputElement":"Input__InputElement__2-aFx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Input/Input.css
// module id = 115
// module chunks = 0